import type { Account } from '@/widgets/Wizard/models/accounts';

export function loadAccountStyles(account: Account) {
    const version = ''; // import.meta.env.VITE_DIST_VERSION === 'smooth' ? '' : `/${import.meta.env.VITE_DIST_VERSION}`;
    const hash = import.meta.env.VITE_DIST_HASH || '' + new Date().getTime();

    const stylesheets = [
        `<link href="https://boekenzuil.3wstaging.nl${version}/css/account/${account.code}.css?r=${hash}" rel="stylesheet">`,
    ];

    document.head.insertAdjacentHTML('beforeend', stylesheets.join(''));
}
